export default {"src":"/_next/static/media/life-ring.401dcab8.svg","height":88,"width":89,"blurWidth":0,"blurHeight":0};